import React, { Component } from 'react';
import { observer } from 'mobx-react';

import DiscountItem from './DiscountItem';

@observer class Discounts extends Component {
  render() {
    const { discounts, contact } = this.props;

    return (
      <div>
        <h4>Staffels</h4>
        <div className="list-group">
          {discounts.map(d => <DiscountItem key={d.recId} discount={d} contact={contact} />)}
        </div>
      </div>
    );
  }
}

Discounts.defaultProps = {
  discounts: []
};

export default Discounts;



// WEBPACK FOOTER //
// ./src/discounts/Discounts.js